import { Injectable, Injector } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { environment } from "../../../../environments/environment";
import { AuthService } from "../../service/auth-service/auth-service.service";
import { LookupGetService } from "../../service/lookup-service/lookup-get.service";
import { SectionService } from "../../service/section-service/section-service";
import { SectionName } from "../SectionName";
import { MeddraSection } from "./MeddraSection";
import { MedicinalProductSection } from "./MedicinalProductSection";
import { ProductReportsSection } from "./ProductReportsSection";
import { Section } from "./Section";
import { WebTraderSection } from "./WebTraderSection";
import { BaseNode } from "../Node/BaseNode";
import { FormlyConfig } from "@ngx-formly/core";
import { PostSection } from "./PostSection";
import { BulkUpdateSection } from "./BulkUpdateSection";
import { BulkExportSection } from "./BulkExportSection";
import { MedicinalproductsService } from "../../service/medicinalproducts-service/medicinalproducts.service";
import { MeddraService } from "../../service/meddra-service/meddra.service";
import { WebtraderService } from "../../service/webtrader-service/webtrader.service";
import { testingEnum } from "../../common/enum/testingEnum";
import { VersionService } from "../../service/version-service/version.service";

@Injectable({
  providedIn: 'root',
})
export class Art57Section {

  selectionSectionName = "";
  webtrader = new WebTraderSection(this.injector, this.authService);
  productReports = new ProductReportsSection(this.injector);
  medicinalProduct = new MedicinalProductSection(this.injector);
  meddra = new MeddraSection(this.injector);
  post = new PostSection(this.injector);
  bulkexport = new BulkExportSection(this.injector);
  bulkupdate = new BulkUpdateSection(this.injector);
  tree_width: number = 400;

  constructor(private injector: Injector,
    private messageService: MessageService,
    public confirmationService: ConfirmationService,
    private componentLoaderService: SectionService,
    private authService: AuthService,
    public formlyConfig: FormlyConfig
  ) {

    //Default section according to user roles
    this.selectionSectionName = this.authService.selectedSection;

    this.authService.getLoginCompleted().subscribe(
      loggedUser => {
        if (loggedUser)
          this.initLookups();
      });

    //Section change subscription
    this.componentLoaderService.componentLoad$.subscribe(sectionName => {
      this.selectionSectionName = sectionName;
    });

  };

  private initLookups() {

    this.injector.get(VersionService).getAPIVersion().subscribe(data => {
       this.injector.get(VersionService).setAPIVersion("API " + data.version);
    });

    this.injector.get(LookupGetService).getAll("operationtype").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("operationtype", data);
    });

    this.injector.get(LookupGetService).getAll("operationtype").subscribe(data => {
      data.push({ code: "7", name: 'DD Update' });
      data.push({ code: "8", name: 'DD Nullification' });
      data.push({ code: "-1", name: 'Total Entity Validation' });
      data.push({ code: "-7", name: 'Entity Validation' });
      this.injector.get(LookupGetService).addToCache("operationtypeoperationresult", data);
    });

    this.injector.get(LookupGetService).addToCache("validityValues", [{ code: 0, name: 'Not Assessed' }, { code: 1, name: 'Valid' }, { code: 2, name: 'Need MAH Follow-Up' }]);

    this.injector.get(LookupGetService).addToCache("pendingValues", [{ code: 0, name: 'Not Assessed' }, { code: 1, name: 'Pending Update' }, { code: 2, name: 'Assessed' }]);

    this.injector.get(LookupGetService).getAll("productstatus").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("productstatus", data);
    });

    this.injector.get(LookupGetService).getAll("productversion").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("productversion", data);
    });

    this.injector.get(LookupGetService).addToCache("productstypes", [{ code: 1, name: 'Development' }, { code: 2, name: 'Authorised' }]);
    this.injector.get(LookupGetService).addToCache("substancestypes", [{ code: 1, name: 'Development' }, { code: 2, name: 'Approved' }]);
    this.injector.get(LookupGetService).addToCache("matchstypes", [{ code: 1, name: 'Preferred' }, { code: 2, name: 'Synonym' }, { code: 3, name: 'Replaced Preferred' }, { code: 4, name: 'Repalced Synonym' }]);

    this.injector.get(LookupGetService).addToCache("typeorg", [{ code: 1, name: 'MAH' }, { code: 2, name: 'Sponsor' }]);

    this.injector.get(LookupGetService).addToCache("type_Term", [{ code: 3, name: 'Standard' }, { code: 2, name: 'Proposed' }, { code: 1, name: 'Development' }]);

    this.injector.get(LookupGetService).getAll("language").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("language", data);
    });

    this.injector.get(LookupGetService).getAll("medicinalproducttype").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("medicinalproducttype", data);
    });

    this.injector.get(LookupGetService).getAll("medicaldevice").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("medicaldevice", data);
    });

    this.injector.get(LookupGetService).getAll("legalbasis").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("legalbasis", data);
    });

    this.injector.get(LookupGetService).getAll("authorisationprocedure").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("authorisationprocedure", data);
    });

    this.injector.get(LookupGetService).getAll("amountvaluetype").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("amountvaluetype", data);
    });

    this.injector.get(LookupGetService).getAll("authorisationstatus").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("authorisationstatus", data);
    });

    this.injector.get(LookupGetService).getAll("authorisationstatus", [["filter", "1|2|8|9|12"]]).subscribe(data => {
      this.injector.get(LookupGetService).addToCache("validauthorisationstatus", data);
    });

    this.injector.get(LookupGetService).getAll("authorisationstatus", [["filter", "3|4|5|6|7|10|11"]]).subscribe(data => {
      this.injector.get(LookupGetService).addToCache("notvalidauthorisationstatus", data);
    });

    this.injector.get(LookupGetService).getAll("authorisationstatus").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("bulkAuthorisationstatus", data);
    });

    this.injector.get(LookupGetService).getAll("country").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("country", data);
    });

    this.injector.get(LookupGetService).getAll("country", [["filter", "LI|EU|NO|IS"]]).subscribe(data => {
      this.injector.get(LookupGetService).addToCache("countryeu", data);
    });

    this.injector.get(LookupGetService).getAll("country", [["iseea", "1"]]).subscribe(data => {
      this.injector.get(LookupGetService).addToCache("countryeea", data);
    });

    this.injector.get(LookupGetService).getAll("country", [["iseea", "0"]]).subscribe(data => {
      this.injector.get(LookupGetService).addToCache("countrynoneea", data);
    });

    this.injector.get(LookupGetService).getAll("country").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("bulkCountry", data);
    });

    this.injector.get(LookupGetService).addToCache("smestatus", [{ code: 4, name: 'Medium' }, { code: 2, name: 'Micro' }, { code: 1, name: 'NA' }, { code: 3, name: 'Small' }]);

    this.injector.get(LookupGetService).addToCache("attachmenttype", [{ code: 1, name: 'PPI' }, { code: 2, name: 'PSI' }]);

    this.injector.get(LookupGetService).addToCache("ppiattachmentfiletype", [{ code: 1, name: 'PDF' }, { code: 2, name: 'DOC' }, { code: 3, name: 'DOCX' }]);

    this.injector.get(LookupGetService).addToCache("psiattachmentfiletype", [{ code: 1, name: 'PDF' }, { code: 2, name: 'DOC' }, { code: 3, name: 'DOCX' }, { code: 4, name: 'XLS' }, { code: 5, name: 'XLSX' }]);

    this.injector.get(LookupGetService).addToCache("roleofingredient", [{ code: 1, name: 'Active Ingredient' }, { code: 2, name: 'Excipient' }, { code: 3, name: 'Adjuvant' }]);

    this.injector.get(LookupGetService).getAll("amountprefix").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("amountprefix", data);
    });

    this.injector.get(LookupGetService).getAll("amountnumerunit").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("amountnumerunit", data);
    });

    this.injector.get(LookupGetService).getAll("amountdenomunit").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("amountdenomunit", data);
    });

    this.injector.get(LookupGetService).getAll("unitofpresentation").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("unitofpresentation", data);
    });

    this.injector.get(LookupGetService).getAll("unitofmeasurement").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("unitofmeasurement", data);
    });

    this.injector.get(LookupGetService).getAll("symbol").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("symbol", data);
    });

    this.injector.get(LookupGetService).getAll("concentrationunitnum").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("concentrationunitnum", data);
    });

    this.injector.get(LookupGetService).getAll("concentrationunitden").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("concentrationunitden", data);
    });

    this.injector.get(LookupGetService).addToCache("substancetype", [{ code: 'SRCPARSUB1', name: 'EV Single Substance' }, { code: 'SRCPARSUB2', name: 'EV Specified Substance Group 1' }, { code: 'SRCPARSUB3', name: 'EV Specified Substance Group 2' }]);

    this.injector.get(LookupGetService).addToCache("validitydeclaration", [{ code: 1, name: 'Valid' }]);

    this.injector.get(LookupGetService).addToCache("substancenameorcode", [{ code: 1, name: 'Code' }, { code: 2, name: 'Name' }]);
    this.injector.get(LookupGetService).addToCache("substanceclass", [{ code: 1, name: 'Chemical' },
    { code: 17, name: 'Mixture' },
    { code: 2, name: 'Nucleic Acid' },
    { code: 3, name: 'Polymer' },
    { code: 4, name: 'Protein - Other' },
    { code: 5, name: 'Protein - Vaccine' },
    { code: 13, name: 'Specified Substance Group 1' },
    { code: 14, name: 'Specified Substance Group 2' },
    { code: 15, name: 'Specified Substance Group 3' },
    { code: 16, name: 'Specified Substance Group 4' },
    { code: 10, name: 'Structurally Diverse Substance - Allergen' },
    { code: 8, name: 'Structurally Diverse Substance - Blood derived' },
    { code: 11, name: 'Structurally Diverse Substance - Cell therapy' },
    { code: 9, name: 'Structurally Diverse Substance - Herbal' },
    { code: 7, name: 'Structurally Diverse Substance - Immunoglobulin' },
    { code: 12, name: 'Structurally Diverse Substance - Other' },
    { code: 6, name: 'Structurally Diverse Substance - Vaccine' },
    ]);

    this.injector.get(LookupGetService).getAll("supportedbacklogmeddraversions").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("supportedbacklogmeddraversions", data);
    });

    this.injector.get(LookupGetService).getAll("supportedmeddraversions").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("supportedmeddraversions", data);
    });

    this.injector.get(LookupGetService).addToCache("meddraLevel",
      [
        { code: 'SOC', name: 'System Organ Class' },
        { code: 'HLGT', name: 'High Level Group Term' },
        { code: 'HLT', name: 'High Level Term' },
        { code: 'PT', name: 'Preferred Term' },
        { code: 'LLT', name: 'Low Level Term' }
      ]);


    this.injector.get(LookupGetService).addToCache("orphanDrug", [{ code: 1, name: 'Yes' }, { code: 2, name: 'No' }]);

    this.injector.get(LookupGetService).addToCache("additionalMonitoring", [{ code: 1, name: 'Yes' }, { code: 2, name: 'No' }]);

    this.injector.get(LookupGetService).addToCache("strength", [{ code: 1, name: 'Units of Measure' }, { code: 2, name: 'Units of Presentation' }]);

    this.injector.get(LookupGetService).getAll("operationresult",[['filter','1']]).subscribe(data => {
      this.injector.get(LookupGetService).addToCache("operationresult", data);
    });

    this.injector.get(LookupGetService).getAll("operationresult").subscribe(data => {
      this.injector.get(LookupGetService).addToCache("operationresultmp", data
        .filter((operation: any) => !['93', '94'].includes(operation['code'])) //ref US-224944: hide operations
        .sort((a: any, b: any) => {
          let nameA = a["name"] || '';
          let nameB = b["name"] || '';

          return nameA.localeCompare(nameB);
        }));
    });

    this.injector.get(LookupGetService).addToCache("reportname", [
      { code: "ATTACHMENT", name: "Attachment" },
      { code: "MFL", name: "Master File Location" },
      { code: "ORGANISATION", name: "Organisation" },
      { code: "SOURCE", name: "Source" },
      { code: "DEVELOPMENTSUBSTANCE", name: "Development Substance" },
      { code: "APPROVEDSUBSTANCE", name: "Approved Subtance" },
      { code: "ATCCODE", name: "ATC Code" },
      { code: "PHARMACEUTICALFORM", name: "Pharmaceutical Form" },
      { code: "ADMINISTRATIONROUTE", name: "Route of Administration" },
      { code: "DEVELOPMENTPRODUCT", name: "Development Product" },
      { code: "AUTHORISEDPRODUCT", name: "Authorised Product" }
    ])
    this.injector.get(LookupGetService).addToCache("yesNo", [{ code: 1, name: 'Yes' }, { code: 2, name: 'No' }]);
    this.injector.get(LookupGetService).addToCache("binaryYesNo", [{ code: 0, name: 'No' }, { code: 1, name: 'Yes' }]);
    this.injector.get(LookupGetService).addToCache("art57Format", [{ code: 0, name: "Article 57 Format" }, { code: 1, name: "Pre Article 57 Format" }, { code: "0|1", name: "Any" }]);
    this.injector.get(LookupGetService).addToCache("interimFormat", [{ code: 0, name: "Pre Interim Format" }, { code: 1, name: "Interim Format" }]);
    this.injector.get(LookupGetService).addToCache("validityFormat", [{ code: 1, name: "Valid" }, { code: 2, name: "Invalid" }, { code: "1|2", name: "Any" }]);
    this.injector.get(LookupGetService).addToCache("interimPrepost", [{ code: 0, name: 'Pre Interim Format' }, { code: 1, name: 'Interim Format' }]);
    this.injector.get(LookupGetService).addToCache("nameTypeProductIndex", [{ code: 0, name: 'Nullified PI' }, { code: 1, name: 'Product' }, { code: 2, name: 'Scientific' }, { code: 3, name: 'Product and Scientific' }]);
    this.injector.get(LookupGetService).addToCache("pispStatus", [{ code: 1, name: 'Active' }, { code: 4, name: 'Nullified' }, { code: 5, name: 'Missing' }, { code: 6, name: 'Hidden' }]);
    this.injector.get(LookupGetService).addToCache("substanceNameTypes", [
      { code: 1, name: 'Preferred' }
      , { code: 2, name: 'Non Preferred' }
      , { code: 3, name: 'Translation' }
      , { code: 4, name: 'Alias' }
      , { code: 5, name: 'Misspelling' }
      , { code: 6, name: 'International Code' }
      , { code: 7, name: 'Old Alias/Translation' }
    ]);

    // TODO: fill req_status 1,3 names instead TBC
    //REMOVED FOR INDUSTRY VERSION (requested by veronika baker in refiment session - 23/06/2025)   this.injector.get(LookupGetService).addToCache("req_status", [{ code: 1, name: 'TBC' }, { code: 2, name: 'Approved' }, { code: 3, name: 'TBC' }]);

    // Bulk Export lookups
    this.injector.get(LookupGetService).addToCache("versiontoexport", [
      { code: 6, name: 'Last' },  // special values for bulk export/update
      { code: 5, name: 'Assessed as Valid' } // special values for bulk export/update
    ]);

    this.injector.get(LookupGetService).addToCache("bulkart57Format", [
      { code: 0, name: "Article 57 Format" },
      { code: 1, name: "Pre Article 57 Format (legacy and maintained by EMA)" }
    ]);

    this.injector.get(LookupGetService).addToCache("bulkinterimFormat", [
      { code: 1, name: "Interim Format" },
      { code: 0, name: "Pre Interim Format" }
    ]);

    this.injector.get(LookupGetService).addToCache("bulkProductTypes", [{ code: 2, name: 'Authorised' }, { code: 1, name: 'Development' }]);

    this.injector.get(LookupGetService).getAll("operationtype", [["filter", "2|6|4"]]).subscribe(data => {
      this.injector.get(LookupGetService).addToCache("bulkupdateoperationtype", data);
    });


    this.injector.get(LookupGetService).addToCache("predicateBulkUpdate", [
      { code: "is", name: "Is" },
      { code: "isnot", name: "Is Not" },
      { code: "ismissing", name: "Is Missing" },
      { code: "isnotmissing", name: "Is Not Missing" }
    ])

    // Bulk Update lookups
    this.injector.get(LookupGetService).addToCache("lookupFilter1", [
      { code: 'ISMISSING', name: 'Is Missing' },
      { code: 'ISNOTMISSING', name: 'Is Not Missing' }
    ]);

    this.injector.get(LookupGetService).addToCache("dynlookupFilter1", [
      { code: 'IS', name: 'Is' },
      { code: 'ISNOT', name: 'Is Not' },
      { code: 'ISMISSING', name: 'Is Missing' },
      { code: 'ISNOTMISSING', name: 'Is Not Missing' }
    ]);

    this.injector.get(LookupGetService).addToCache("lookupFilter2", [
      { code: 'CONTAINS', name: 'Contains' },
      { code: 'DOESNTCONTAIN', name: 'Doesn\'t Contain' },
      { code: 'ISMISSING', name: 'Is Missing' },
      { code: 'ISNOTMISSING', name: 'Is Not Missing' }
    ]);

    this.injector.get(LookupGetService).addToCache("dynlookupFilter2", [
      { code: 'CONTAINS', name: 'Contains' },
      { code: 'DOESNTCONTAIN', name: 'Doesn\'t Contain' },
      { code: 'IS', name: 'Is' },
      { code: 'ISNOT', name: 'Is Not' },
      { code: 'ISMISSING', name: 'Is Missing' },
      { code: 'ISNOTMISSING', name: 'Is Not Missing' }
    ]);

    this.injector.get(LookupGetService).addToCache("lookupFilter3", [
      { code: 'ISMISSING', name: 'Is Missing' },
      { code: 'ISNOTMISSING', name: 'Is Not Missing' }
    ]);

    this.injector.get(LookupGetService).addToCache("lookupChange1", [
      { code: 'CHANGE', name: 'Change' },
    ]);

    this.injector.get(LookupGetService).addToCache("lookupChange2", [
      { code: 'CHANGE', name: 'Change' },
      { code: 'ASSIGN', name: 'Assign' },
    ]);

    this.injector.get(LookupGetService).addToCache("dynlookupChange2", [
      { code: 'CHANGE', name: 'Change' },
      { code: 'ASSIGN', name: 'Assign' },
      { code: 'REMOVE', name: 'Remove' },
    ]);

    this.injector.get(LookupGetService).addToCache("lookupChange3", [
      { code: 'PREPEND', name: 'Prepend' },
      { code: 'APPEND', name: 'Append' },
      { code: 'CHANGE', name: 'Change' },
    ]);

    this.injector.get(LookupGetService).addToCache("lookupChange4", [
      { code: 'PREPEND', name: 'Prepend' },
      { code: 'APPEND', name: 'Append' },
      { code: 'CHANGE', name: 'Change' },
      { code: 'ASSIGN', name: 'Assign' },
    ]);

    this.injector.get(LookupGetService).addToCache("dynlookupChange4", [
      { code: 'PREPEND', name: 'Prepend' },
      { code: 'APPEND', name: 'Append' },
      { code: 'CHANGE', name: 'Change' },
      { code: 'ASSIGN', name: 'Assign' },
      { code: 'REMOVE', name: 'Remove' },
    ]);

    this.injector.get(LookupGetService).addToCache("lookupChange5", [
      { code: 'ADD', name: 'Add' },
    ]);

    this.injector.get(LookupGetService).addToCache("dynlookupChange5", [
      { code: 'ADD', name: 'Add' },
      { code: 'REMOVE', name: 'Remove' },
    ]);

    this.injector.get(LookupGetService).addToCache("lookupChange6", [
      { code: 'ASSIGN', name: 'Assign' },
    ]);

  }

  setSelectedSection(newSection: string) {
    this.selectionSectionName = newSection;
    switch (this.selectionSectionName) {
      case SectionName.webtrader:
        this.componentLoaderService.loadSection(SectionName.webtrader);
        break;
      case SectionName.createandsendproductreports:
        this.componentLoaderService.loadSection(SectionName.createandsendproductreports);
        break;
      case SectionName.medicinalproducts:
        this.componentLoaderService.loadSection(SectionName.medicinalproducts);
        break;
      case SectionName.meddra:
        this.componentLoaderService.loadSection(SectionName.meddra);
        break;
      case SectionName.post:
        this.componentLoaderService.loadSection(SectionName.post);
        break;
      case SectionName.bulkexport:
        this.componentLoaderService.loadSection(SectionName.bulkexport);
        break;
      case SectionName.bulkupdate:
        this.componentLoaderService.loadSection(SectionName.bulkupdate);
        break;
    }
  }

  getSelectedSection(): any {
    switch (this.selectionSectionName) {
      case SectionName.webtrader:
        return this.webtrader;
      case SectionName.createandsendproductreports:
        return this.productReports;
      case SectionName.medicinalproducts:
        return this.medicinalProduct;
      case SectionName.meddra:
        return this.meddra;
      case SectionName.post:
        return this.post;
      case SectionName.bulkexport:
        return this.bulkexport;
      case SectionName.bulkupdate:
        return this.bulkupdate;
      default:
        return null;
    }
  }

  isCreateAndSendProductSection() {
    return (this.getSelectedSection() == this.productReports);
  }

  disableFormlyFields() {
    return this.isWebtraderSection();
  }

  isMeddraSection() {
    return (this.getSelectedSection() == this.meddra);
  }

  isWebtraderSection() {
    return (this.getSelectedSection() == this.webtrader);
  }

  isMedicinalProductSection() {
    return (this.getSelectedSection() == this.medicinalProduct);
  }

  isBulkExportSection() {
    return this.getSelectedSection() == this.bulkexport;
  }

  isBulkUpdateSection() {
    return this.getSelectedSection() == this.bulkupdate;
  }


  public initSections() {
    this.webtrader.resetSection();
    this.productReports.resetSection();
    this.medicinalProduct.resetSection();
    this.meddra.resetSection();
    this.post.resetSection();
    this.bulkexport.resetSection();
    this.bulkupdate.resetSection();
  }

  public resetApplication(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.confirmationService.confirm({
        header: 'Reset Application',
        message: 'You will loose all the Sections Data.<br><br>Are You sure?',
        icon: 'pi pi-question-circle',
        acceptLabel: 'OK',
        rejectLabel: 'Cancel',
        accept: () => {
          this.initSections();
          resolve(true);

          this.showTooltipMessage({ severity: 'success', id: testingEnum.appResetToastMsg, detail: 'Application has been reset', life: environment.successElapsedTime });
        },
        reject: () => {
          resolve(false);
        }
      });
    });
  }

  public resetSection(sectionToReset: Section): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.confirmationService.confirm({

        header: 'Reset Section',
        message: 'You will loose all this Section Data.<br><br>Are You sure?',
        icon: 'pi pi-question-circle',
        acceptLabel: 'OK',
        rejectLabel: 'Cancel',
        accept: () => {
          sectionToReset.resetSection();
          this.componentLoaderService.loadSection(this.selectionSectionName);
          this.showTooltipMessage({ severity: 'success', id: testingEnum.sectionResetToastMsg, detail: 'Section has been reset', life: environment.successElapsedTime });
          resolve(true);
        },
        reject: () => {
          resolve(false);
        }
      });
    });
  }

  public changeSelectAll(selectedNode: BaseNode, newValue: boolean) {
    selectedNode.children!.forEach(child => { child.checked = newValue; });
  }

  showTooltipMessage(messageStructure: any) {
    this.messageService.add(messageStructure);
  }

  showWarningTooltipMessage(messageDetail: any, messageSummary?: String, lifetime?: number, id?: string): void {
    lifetime = lifetime ?? environment.warningElapsedTime;
    id = id ?? '';
    this.showTooltipMessage({ severity: 'warn', id: id, detail: `${messageDetail}`, summary: messageSummary, life: lifetime });
  }

  showErrorTooltipMessage(messageDetail: any, messageSummary?: String, lifetime?: number, id?: string): void {
    lifetime = lifetime ?? environment.errorElapsedTime;
    id = id ?? '';
    this.showTooltipMessage({ severity: 'error', id: id, detail: `${messageDetail}`, summary: messageSummary, life: lifetime });
  }

  showSuccessTooltipMessage(messageDetail: any, messageSummary?: String, lifetime?: number, id?: string): void {
    lifetime = lifetime ?? environment.successElapsedTime;
    id = id ?? '';
    this.showTooltipMessage({ severity: 'success', id: id, detail: `${messageDetail}`, summary: messageSummary, life: lifetime });
  }

  generateNumColumValue(node: BaseNode) {
    if (node.parent) {
      const nums = node.parent.children?.map((c: any) => c.num).filter(num => num !== "");;
      if (nums && nums.length > 0) {
        const orderedNums: any[] | undefined = nums!.sort((a, b) => b - a);
        node.num = ((Number.parseInt(orderedNums[0])) + 1).toString().padStart(4, '0');
      } else {
        node.num = (1).toString().padStart(4, '0');;
      }
    }

  }

  displayErrors(node: any) {

    const errors = node.fieldsErrorsControl.getErrors();
    if (errors.length > 0) {

      let errorsMessage: string = `<strong>Some fields may not have been decoded for ${node.label}</strong>`;
      errors.forEach((errorObject: any) => {
        errorsMessage = errorsMessage + '<br><br>' + errorObject.node.label + '<br>' +
          (errorObject.controlLabel ? errorObject.controlLabel + ' = ' : '') +
          errorObject.error;

      });
      this.confirmationService.confirm({
        header: 'Remote reference errors',
        message: errorsMessage,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Accept',
        rejectVisible: false,
      });
    }
  }

  removeIsLoading() {
    this.injector.get(MedicinalproductsService).loading.next(false);
    this.injector.get(WebtraderService).loading.next(false);
    this.injector.get(MeddraService).loading.next(false);
  }
}